/**
 * Barrel export for all database triggers
 * This file re-exports all trigger constants organized by entity type
 */

// ====================================================================
// EXTERNAL TRANSACTION SOFT DELETE TRIGGERS
// ====================================================================
export { TR_EXPENSES_SOFT_DELETE_EXTERNAL } from './external-transactions/expenses-soft-delete.trigger';
export { TR_INCOMES_SOFT_DELETE_EXTERNAL } from './external-transactions/incomes-soft-delete.trigger';
export { TR_ACCOUNT_TRANSFERS_SOFT_DELETE_EXTERNAL } from './external-transactions/account-transfers-soft-delete.trigger';
export { TR_EXCHANGES_SOFT_DELETE_EXTERNAL } from './external-transactions/exchanges-soft-delete.trigger';

// ====================================================================
// CATEGORY TRIGGERS
// ====================================================================
export { TR_CATEGORIES_HARD_DELETE } from './categories/hard-delete.trigger';
export { TR_CATEGORIES_SOFT_DELETE } from './categories/soft-delete.trigger';

// ====================================================================
// INCOME TRIGGERS
// ====================================================================
export { TR_INCOMES_INSERT } from './incomes/insert.trigger';
export { TR_INCOMES_DELETE } from './incomes/delete.trigger';
export { TR_INCOMES_UPDATE } from './incomes/update.trigger';
export { TR_INCOMES_SOFT_DELETE } from './incomes/soft-delete.trigger';

// ====================================================================
// EXPENSE TRIGGERS
// ====================================================================
export { TR_EXPENSES_INSERT } from './expenses/insert.trigger';
export { TR_EXPENSES_DELETE } from './expenses/delete.trigger';
export { TR_EXPENSES_UPDATE } from './expenses/update.trigger';
export { TR_EXPENSES_SOFT_DELETE } from './expenses/soft-delete.trigger';

// ====================================================================
// CURRENCY TRIGGERS
// ====================================================================
export { TR_CURRENCIES_INSERT } from './currencies/insert.trigger';
export { TR_CURRENCIES_HARD_DELETE } from './currencies/hard-delete.trigger';
export { TR_CURRENCIES_UPDATE_DEFAULT } from './currencies/update-default.trigger';
export { TR_CURRENCIES_SOFT_DELETE } from './currencies/soft-delete.trigger';
export { TR_CURRENCIES_UPDATE_POSITION } from './currencies/update-position.trigger';
export { TR_CURRENCIES_INSERT_FIX_POSITION } from './currencies/insert-fix-position.trigger';

// ====================================================================
// ACCOUNT TRIGGERS
// ====================================================================
export { TR_ACCOUNTS_INSERT } from './accounts/insert.trigger';
export { TR_ACCOUNTS_HARD_DELETE } from './accounts/hard-delete.trigger';
export { TR_ACCOUNTS_SOFT_DELETE } from './accounts/soft-delete.trigger';
export { TR_ACCOUNTS_UPDATE_POSITION } from './accounts/update-position.trigger';
export { TR_ACCOUNTS_INSERT_FIX_POSITION } from './accounts/insert-fix-position.trigger';

// ====================================================================
// CREDITOR TRIGGERS
// ====================================================================
export { TR_CREDITORS_INSERT } from './creditors/insert.trigger';
export { TR_CREDITORS_DELETE } from './creditors/delete.trigger';
export { TR_CREDITORS_UPDATE } from './creditors/update.trigger';
export { TR_CREDITORS_SOFT_DELETE } from './creditors/soft-delete.trigger';

// ====================================================================
// CREDITOR PAYMENT TRIGGERS
// ====================================================================
export { TR_CREDITOR_PAYMENTS_INSERT } from './creditor-payments/insert.trigger';
export { TR_CREDITOR_PAYMENTS_DELETE } from './creditor-payments/delete.trigger';
export { TR_CREDITOR_PAYMENTS_UPDATE } from './creditor-payments/update.trigger';
export { TR_CREDITOR_PAYMENTS_SOFT_DELETE } from './creditor-payments/soft-delete.trigger';

// ====================================================================
// DEBTOR TRIGGERS
// ====================================================================
export { TR_DEBTORS_INSERT } from './debtors/insert.trigger';
export { TR_DEBTORS_DELETE } from './debtors/delete.trigger';
export { TR_DEBTORS_UPDATE } from './debtors/update.trigger';
export { TR_DEBTORS_SOFT_DELETE } from './debtors/soft-delete.trigger';

// ====================================================================
// DEBTOR PAYMENT TRIGGERS
// ====================================================================
export { TR_DEBTOR_PAYMENTS_INSERT } from './debtor-payments/insert.trigger';
export { TR_DEBTOR_PAYMENTS_DELETE } from './debtor-payments/delete.trigger';
export { TR_DEBTOR_PAYMENTS_UPDATE } from './debtor-payments/update.trigger';
export { TR_DEBTOR_PAYMENTS_SOFT_DELETE } from './debtor-payments/soft-delete.trigger';

// ====================================================================
// ACCOUNT TRANSFER TRIGGERS
// ====================================================================
export { TR_ACCOUNT_TRANSFERS_INSERT } from './account-transfers/insert.trigger';
export { TR_ACCOUNT_TRANSFERS_DELETE } from './account-transfers/delete.trigger';
export { TR_ACCOUNT_TRANSFERS_UPDATE } from './account-transfers/update.trigger';
export { TR_ACCOUNT_TRANSFERS_SOFT_DELETE } from './account-transfers/soft-delete.trigger';

// ====================================================================
// EXCHANGE TRIGGERS
// ====================================================================
export { TR_EXCHANGES_INSERT } from './exchanges/insert.trigger';
export { TR_EXCHANGES_DELETE } from './exchanges/delete.trigger';
export { TR_EXCHANGES_UPDATE } from './exchanges/update.trigger';
export { TR_EXCHANGES_SOFT_DELETE } from './exchanges/soft-delete.trigger';

// ====================================================================
// ACCOUNT INITIAL BALANCE TRIGGERS
// ====================================================================
export { TR_ACCOUNT_INITIAL_BALANCES_INSERT } from './account-initial-balances/insert.trigger';
export { TR_ACCOUNT_INITIAL_BALANCES_DELETE } from './account-initial-balances/delete.trigger';
export { TR_ACCOUNT_INITIAL_BALANCES_UPDATE } from './account-initial-balances/update.trigger';
export { TR_ACCOUNT_INITIAL_BALANCES_SOFT_DELETE } from './account-initial-balances/soft-delete.trigger';
